import type { LocationQueryRaw } from 'vue-router'

export const useBackParentRoute = async (
  parentPath: string,
  query?: LocationQueryRaw
) => {
  if (window.history.state.back) {
    await useNavigations({ type: 'back' })
  } else {
    await useNavigations({ url: parentPath, type: 'push', query })
  }
}
